export const AIR_SEARCH_TYPE = 'AIR_SEARCH';
export const HOTEL_SEARCH_TYPE = 'HOTEL_SEARCH';
export const MAX_SEARCHES_TO_SHOW = 3;
export const CLEAR_SEARCH_POSITION = 0;
export const CLEAR = 'CLEAR';
export const JOURNEY_TYPE = 'JOURNEY_TYPE';
